module.exports = __webpack_public_path__ + "static/Raleway-Italic-VariableFont_wght-55613c22f51415355f4fc3ea81b22486.woff2";